import { Empty } from "antd";
import SelectAllCard from "../selectAll";
import SalaryUploadCard from "../salaryUpload";
import { useTranslation } from "react-i18next";

export default function SalaryUploadList({
  dataSource = [],
  handleSelectAll,
  handleMultiApproveOrReject,
  selectAllChecked,
  handleMultiDelete,
  handleCheckBoxChange,
  handleApproveOrReject,
  handleDelete,
  handleSingleRcordDownload
}) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })} />
      ) : (
        <div>
          <div>
            <SelectAllCard
              record={dataSource}
              handleSelectAll={handleSelectAll}
              handleMultiApproveOrReject={handleMultiApproveOrReject}
              selectAllChecked={selectAllChecked}
              handleMultiDelete={handleMultiDelete}
            />
          </div>
          <div>
            {dataSource.map((option, index) => (
                <SalaryUploadCard
                  record={option}
                  handleCheckBoxChange={handleCheckBoxChange}
                  handleApproveOrReject={handleApproveOrReject}
                  handleDelete={handleDelete}
                  handleSingleRcordDownload={handleSingleRcordDownload}
                />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
